import React from 'react';
import '../style/TopBrands.css';
import { topBrands } from '../data/topBrandsData'; // <--- import here

// ✅ CDN Base Path (S3 "TOP BRANDS" folder)
const CDN_BASE = "https://cdn.greateastern.in/GETCO/TOP%20BRANDS/";

const TopBrands = () => {
  return (
    <div className="top-brands-container">
      <h2 className="top-brands-heading">Top Brands</h2>
      <div className="brands-grid">
        {topBrands.map((brand, index) => {
          // ✅ Construct CDN URL
          const imgUrl = `${CDN_BASE}${brand.id}`;

          return (
            <div className="brand-card" key={index}>
              {/* 🔥 Replaced Cloudinary <AdvancedImage> with simple <img> */}
              <img src={imgUrl} alt={brand.name} className="brand-logo" />

              {/* Uncomment if needed */}
              {/* <p className="brand-name">{brand.name}</p> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TopBrands;
